export default [
  {
    path: '/robot/robotlist',
    name: '/robot/robotlist',
    meta: {
      title: '机器人'
    },
    component: () =>
      import( /* webpackChunkName: "example-robot" */ '../views/robot/robotlist.vue')
  },
  {
    path: '/robot/robotlistDetails',
    name: '/robot/robotlistDetails',
    meta: {
      title: '新建机器人'
    },
    component: () =>
      import( /* webpackChunkName: "example-robot" */ '../views/robot/robotlistDetails.vue')
  },
  {
    path: '/robot/session',
    name: '/robot/session',
    meta: {
      title: '机器人会话'
    },
    component: () =>
      import( /* webpackChunkName: "example-robot" */ '../views/robot/robotSession.vue')
  },
  {
    path: '/robot/session-detail',
    name: '/robot/session-detail',
    meta: {
      title: '机器人会话明细'
    },
    component: () =>
      import( /* webpackChunkName: "example-robot" */ '../views/robot/robotSessionDetail.vue')
  },
]